function checkLoginUrl(){
    var url = window.location.href;
  	if (url.indexOf('#recover') > -1) {
      console.log('this is recover');
      $('.jsLoginBlock').addClass('d-none');
      $('#jsLoginRecover').removeClass('d-none');
    }
    
    if(url.indexOf('#login') > -1) {
      console.log('this is login');
      $('.jsLoginBlock').addClass('d-none');
      $('#jsLogin').removeClass('d-none');
    }
    
    if(url.indexOf('checkout_url') > -1) {
      console.log('this is checkout');
      $('.jsLoginBlock').addClass('d-none');
      $('#jsGuestLogin').removeClass('d-hide');
    }
  };

function initProvince($form, selectedCountry){
  var addressId = $form.data('address-id');
  var $country = $('#AddressCountry_' + addressId);
  var $province = $('#AddressProvince_' + addressId);
  if(typeof selectedCountry == 'undefined'){
    selectedCountry = $country.data('default');
  }
  var selectedProvince = $province.data('default');
  var arrProvinces = $country.find('option[value="' + selectedCountry + '"]').data('provinces');

  $country.find('option[value="' + selectedCountry + '"]').attr('selected', 'selected');
  $province.empty();

  console.log(selectedCountry);

  if(typeof arrProvinces !== 'undefined' && arrProvinces.length > 0) {
    $.each(arrProvinces, function(i, val){
      var propSelected = '';
      if(val[0] == selectedProvince) {
        propSelected = ' selected="selected"';
      }
  
      var htmlOption = '<option value="'+ val[0] + '"' + propSelected + '>'+ val[1]+'</option>';

      $('#AddressProvinceContainer_' + addressId).removeClass('hide');
      $province.append(htmlOption);
    });
  } else {
    $('#AddressProvinceContainer_' + addressId).addClass('hide');
  }

}

function customerAddress(){
  $('html').on('click', '.jsEditAddress-btn', function(){
    var addressId = $(this).data('address-id');
    var $form = $('#jsEditAddress_' + addressId);

    $('.jsListAddress').addClass('hide');
    initProvince($form);
    $form.removeClass('hide');
  });

  $('html').on('change', '.jsSelect-country', function(){
    var selected = $(this).val();
    var addressId = $(this).data('form-id');
    var $form = $('#jsEditAddress_' + addressId);
    initProvince($form, selected);
  });

  $('.jsAddAddress-btn').click(function(){
    $('.jsListAddress').addClass('hide');
    $('#jsAddAddress').removeClass('hide');
  });

  $('.jsAddressReset').click(function(){
    var $form = $(this).parents('.jsEditAddress');
    $form.addClass('hide');
    $('.jsListAddress').removeClass('hide');
  });

  
};


$(function(){
  'use strict';

  $('html').on('click', '.jsCheckLoginUrl', function(){
    setTimeout(function(){
       checkLoginUrl();
    }, 500);
  });

  customerAddress();
});